import React, { useState, useEffect, useRef } from 'react';
import Permiso from '../../components/sturtural/Permiso';
import Menu from '../../components/sturtural/Menu';
import Loader from '../../components/sturtural/Loader';
import MessageDetail from '../../components/sturtural/MessageDetail';
import { useParams } from "react-router";
import { BASE_API } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { useNavigate } from 'react-router-dom';
import ScannerFiltro from '../../components/sturtural/ScannerFiltro';
import { Tooltip } from 'primereact/tooltip';
import { DataScroller } from 'primereact/datascroller';
import { Checkbox } from 'primereact/checkbox';
import { Messages } from 'primereact/messages';
import { Chip } from 'primereact/chip';
import { Dropdown } from 'primereact/dropdown';
import { storage } from '../../helpers/storage';


// inicio busqueda por folio
const initialFormFolio = {
    folio: ""
}

// busqueda por datos del alumno
const initialFormData = {
    curp: "",
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    nivel: null
}

// validacion formulario por folio
const validationsFromFolio = (folio) => {
    let errors = {};
    const regexNum = /^\d+$/;

    if (!folio.folio.trim()) {
        errors.folio = "El campo (cupu) es requerido";
    } else {
        if (!regexNum.test(folio.folio.trim())) {
            errors.folio = "El campo (cupu) solo acepta números";
        }
    }
    return errors;
}

//validacion de formulario por datos
const validationsFromData = (data) => {
    let errors = {};

    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;
    if (!data.curp.trim()) {
        if (!data.nombre.trim()) {
            errors.nombre = "El Campo (nombre) es requerido";
        } else if (!regexName.test(data.nombre.trim())) {
            errors.nombre = "El Campo (nombre) sólo acepta letras y espacios en blanco";
        }

        if (!data.apellido_paterno.trim()) {
            errors.apellido_paterno = "El Campo (Primer apellido) es requerido";
        } else if (!regexName.test(data.apellido_paterno.trim())) {
            errors.apellido_paterno = "El Campo (Primer apellido) sólo acepta letras y espacios en blanco";
        }
    }

    return errors;
}

// inicio agregar tutor
const initialFormNuevoTutor = {
    nombre: "",
    apellido1: "",
    apellido2: "",
    idTipoTutor: 0
}

//validacion de formulario tutor
const validationsFrom_NuevoTutor = (data) => {
    let errors = {};
    let regexName = /^[A-Za-zÑñÁáÉéÍíÓóÚúÜü\s]+$/;

    if (!data.nombre.trim()) {
        errors.nombre = "El campo (nombre) es requerido";
    } else if (!regexName.test(data.nombre.trim())) {
        errors.nombre = "El campo (nombre) no acepta números ni caracteres especiales";
    }

    if (!data.apellido1.trim()) {
        errors.apellido1 = "El campo (primer apellido) es requerido";
    } else if (!regexName.test(data.apellido1.trim())) {
        errors.apellido1 = "El campo (primer apellido) no acepta números ni caracteres especiales";
    }

    if (data.apellido2.trim()) {
        if (!regexName.test(data.apellido2.trim())) {
            errors.apellido2 = "El campo (segundo apellido) no acepta números ni caracteres especiales";
        }
    } else {
        console.log("Campo segundo apellido no es obligatorio");
    }

    /*  if (data.idTipoTutor === null) {
         errors.idTipoTutor = "El campo (tipo tutor) es requerido";
     } */

    return errors;
}

const Filtro = () => {
    const navigate = useNavigate();

    const [folio, setFolio] = useState(initialFormFolio);
    const [errors, setErrors] = useState(true);
    const [loading, setLoading] = useState(false);
    const [banderaEscaner, setBanderaEscaner] = useState(false);
    const [getNivel, setGetNivel] = useState([])

    const [data, setData] = useState(initialFormData);
    const [dataY, setDataY] = useState(false)
    const [dataErrors, setDataErrors] = useState(true);
    const [dataLoading, setDataLoading] = useState(false);

    const [tutor, setTutor] = useState(initialFormNuevoTutor);
    const [errors_nuevo_tutor, setErrors_NuevoTutor] = useState(true);
    const [loading_nuevo_tutor, setLoading_NuevoTutor] = useState(false);
    const [alumnoId, setAlumnoId] = useState(null);
    const [alumno, setAlumno] = useState(null);
    const [alumnoY, setAlumnoY] = useState(null);
    const [cupu, setCupu] = useState(null);

    const [alumnos, setAlumnos] = useState(null);
    const [tutores, setTutores] = useState(false);
    const [form_tutor, setFormAdd_tutor] = useState(false);
    const [form_tutor2, setFormAdd_tutor2] = useState(false);
    const [lstTipoTutor, setLstTipoTutor] = useState([]);

    const [lista, setLista] = useState(false);

    const [IdAlumno, setIdAlumno] = useState(null);
    const [IdTutor, setIdTutor] = useState(null);

    const [aviso, setAviso] = useState(false);
    const [message, setMessage] = useState(false);
    const [avisoY, setAvisoY] = useState(false);
    const [messageY, setMessageY] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [banderaGeneral, setBanderaGeneral] = useState(false);

    const [displayConfirmation, setDisplayConfirmation] = useState(false);
    const [displayConfirmation2, setDisplayConfirmation2] = useState(false);
    const [displayConfirmation3, setDisplayConfirmation3] = useState(false);
    const [displayConfirmationMulti, setDisplayConfirmationMulti] = useState(false);
    const [confirmScanner, setConfirmScanner] = useState(false);
    const [loadingVale, setLoadingVale] = useState(false);
    const [loadingYoremia, setLoadingYoremia] = useState(false);
    const [botonY, setBotonY] = useState(false)

    const [dataMulti, setDataMulti] = useState(storage.get('alumnosMulti') !== null ? storage.get('alumnosMulti') : []);
    const [dialogTutoresMulti, setDialogTutoresMulti] = useState(false);
    const [checkboxValue, setCheckboxValue] = useState([]);
    const msgs = useRef(null)

    const perfil =storage.get('perfilid');
    const ciclo = storage.get('ciclo');
    const idUsuario = storage.get('id');
    const idTienda = storage.get("IdTienda")

    let tempTutores = []

    useEffect(() => {
        if (![1, 2, 3, 5, 13, 19, 16, 17, 20, 21].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    useEffect(() => {
        helpHttp().get(`${BASE_API}BusquedaAlumnos/GetRptNivel`, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                if (res.ITEMS.SUCCESS) {
                    //let item = { code: 0, name: "Todos" }
                    //res.ITEMS.ITEMS.unshift(item)
                    setGetNivel(res.ITEMS.ITEMS)
                    setData({ ...data, nivel: res.ITEMS.ITEMS[0].code })
                }
            }
        })
    }, [])

    const isNormalInteger = (str) => {
        let n = ~~Number(str);
        return String(n) === str && n >= 0;
    }

    let { q } = useParams();
    useEffect(() => {
        //console.log(q);
        if (isNormalInteger(q)) {
            const arrUser = {
                "IdAlumno": 0,
                "Nombre": "",
                "ApellidoPaterno": "",
                "ApellidoMaterno": "",
                "Curp": "",
                "NombreTutor": "",
                "ApellidoPaternoTutor": "",
                "ApellidoMaternoTutor": "",
                "OrderBy": "",
                "IdEscuela": 0,
                "Codigo": "",
                "Grado": "",
                "Grupo": "",
                "IdTurno": 0,
                "IdTienda": 0,
                "Pagina": 1,
                "Folio": q,
                "IdEstatus": -1,
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "IdNivel": 0
            };

            setLoading(true);

            helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                let arrAlumnos = res.Result;
                if (arrAlumnos?.length > 0) {
                    setTutores(null);
                    setAlumnos(arrAlumnos);
                    setLista(true);

                    if (arrAlumnos[0].IdEstatus === 0) {
                        //handleFind_tutores_x_alumno(arrAlumnos[0].IdAlumno);
                    }
                } else {
                    setMessage("No se encontró información");
                    setAlumnos(null);
                    setAviso(true);
                }
            });
            setLoading(false);
        }
    }, [q]);

    const getTipoTutor = () => {
        helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                opcion: 0,
                sp: "SpdGetTipoTutor",
                parametros: []
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setLstTipoTutor(res.ITEMS)
            }
        })
    }

    const handlerRedirect = () => {
        if (redirect) {
            // navigate("/pendientes"); //Funcion deshabilitada
        } else {
            setAviso(false);
            setMessage(false);
            setDataY(false)
        }
        if (banderaEscaner === true) {
            setConfirmScanner(true);
        }
        setLista(false);
        setBotonY(false)
        setBanderaGeneral(false)
    }

    const handleConfirmation = (_IdTutor, _IdAlumno) => {
        setIdTutor(_IdTutor);
        setIdAlumno(_IdAlumno);
        dataMulti.length > 0 ? setDisplayConfirmation2(true) : setDisplayConfirmation(true)

    }

    const handleConfirmationMulti = () => {
        if (checkboxValue.length > 0) {
            setDisplayConfirmationMulti(true)
            setDialogTutoresMulti(!dialogTutoresMulti);
        } else {
            msgs.current.show({ sticky: true, severity: 'warn', detail: 'Debe seleccionar a un tutor.', closable: false })
        }

    }

    const handleFind_alumno_folio = async (e) => {
        e.preventDefault();

        setErrors(validationsFromFolio(folio));

        if (Object.keys(validationsFromFolio(folio)).length === 0) {

            const arrUser = {
                "IdAlumno": 0,
                "Nombre": "",
                "ApellidoPaterno": "",
                "ApellidoMaterno": "",
                "Curp": "",
                "NombreTutor": "",
                "ApellidoPaternoTutor": "",
                "ApellidoMaternoTutor": "",
                "OrderBy": "",
                "IdEscuela": 0,
                "Codigo": "",
                "Grado": "",
                "Grupo": "",
                "IdTurno": 0,
                "IdTienda": 0,
                "Pagina": 1,
                "Folio": Number(folio.folio),
                "IdEstatus": -1,
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "IdNivel": 0
            };

            setLoading(true);

            // búsqueda por folio

            helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                let arrAlumnos = res.Result;
                if (arrAlumnos?.length > 0) {
                    if (arrAlumnos[0].IdEstatusInscripcion !== 4 || (arrAlumnos[0].IdEstatusInscripcion == 4 && arrAlumnos[0].IdEstatus !== 1)) {
                        setTutores(null);
                        setAlumnos(arrAlumnos);
                        setLista(true);
                    } else {
                        setMessage("Folio dado de baja.");
                        setAlumnoY(arrAlumnos[0]);
                        setAviso(true);
                        setBotonY(true)
                    }
                } else {
                    setMessage("No se encontró información");
                    setAviso(true);
                }
                setLoading(false);
            });
        } else {
            setMessage("Favor de ingresar un cupu para la búsqueda");
            setAviso(true);
            return;
        }
    };

    const handleFind_alumno_x_data = async (e) => {
        e.preventDefault();
        setDataLoading(true);
        setDataErrors(validationsFromData(data));
        if (Object.keys(validationsFromData(data)).length === 0) {
            const arrUser = {
                "IdAlumno": 0,
                "Nombre": data.nombre,
                "ApellidoPaterno": data.apellido_paterno,
                "ApellidoMaterno": data.apellido_materno,
                "Curp": data.curp,
                "NombreTutor": "",
                "ApellidoPaternoTutor": "",
                "ApellidoMaternoTutor": "",
                "OrderBy": "",
                "IdEscuela": 0,
                "Codigo": "",
                "Grado": "",
                "Grupo": "",
                "IdTurno": 0,
                "IdTienda": 0,
                "Pagina": 1,
                "Folio": "",
                "IdEstatus": -1,
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "IdNivel": data.nivel
            };


            helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
                body: arrUser,
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                },
            }).then((res) => {
                let arrAlumnos = res.Result;
                if (arrAlumnos?.length > 0) {
                    if (arrAlumnos[0].IdEstatusInscripcion !== 4 || (arrAlumnos[0].IdEstatusInscripcion == 4 && arrAlumnos[0].IdEstatus !== 1)) {
                        setTutores(null);
                        setAlumnos(arrAlumnos);
                        setLista(true);
                        setDataLoading(false);
                    } else {
                        setMessage("Folio dado de baja.");
                        setAlumnoY(arrAlumnos[0]);
                        setAviso(true);
                        setBotonY(true)
                        setDataLoading(false);
                    }
                } else {
                    setMessage("No se encontró información");
                    setBotonY(true);
                    setBanderaGeneral(true)
                    setAlumnoY({
                        IdNivel: data.nivel,
                        nombre: `${data.nombre.trim()}${data.apellido_paterno}${data.apellido_materno} `,
                        Curp: data.curp
                    })
                    setAlumnos(null);
                    setAviso(true);
                    setDataLoading(false);
                }
            });

        } else {
            setMessage("Favor de llenar los campos para la búsqueda");
            setAviso(true);
            setDataLoading(false);
            return;
        }
    };

    const handleShowForm_NuevoTurtor = (_IdAlumno, _cupu) => {
        setAlumnoId(_IdAlumno);
        setCupu(_cupu);
        getTipoTutor();
        setFormAdd_tutor(true);
        setLista(false)
    }

    const handleShowForm_NuevoTurtor2 = (_IdAlumno, _cupu) => {
        setAlumnoId(_IdAlumno);
        setCupu(_cupu);
        getTipoTutor();
        setFormAdd_tutor2(true);
        setDialogTutoresMulti(false)
    }

    const carga = (_folio) => {
        const arrUser = {
            "IdAlumno": 0,
            "Nombre": "",
            "ApellidoPaterno": "",
            "ApellidoMaterno": "",
            "Curp": "",
            "NombreTutor": "",
            "ApellidoPaternoTutor": "",
            "ApellidoMaternoTutor": "",
            "OrderBy": "",
            "IdEscuela": 0,
            "Codigo": "",
            "Grado": "",
            "Grupo": "",
            "IdTurno": 0,
            "IdTienda": 0,
            "Pagina": 1,
            "Folio": Number(_folio),
            "IdEstatus": -1,
            "IdCicloEscolar": ciclo.IdCicloEscolar,
            "IdNivel": 0
        };

        setLoading(true);

        helpHttp().post(`${BASE_API}BusquedaAlumnos/BusquedaAlumnosApp`, {
            body: arrUser,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            let arrAlumnos = res.Result;
            if (arrAlumnos?.length > 0) {
                if (arrAlumnos[0].IdEstatusInscripcion !== 4 || (arrAlumnos[0].IdEstatusInscripcion == 4 && arrAlumnos[0].IdEstatus !== 1)) {
                    setTutores(null);
                    setAlumnos(arrAlumnos);
                    setLista(true);
                } else {
                    setMessage("Folio dado de baja.");
                    setAlumnos(null);
                    setAviso(true);
                }
            } else {
                setMessage("No se encontró información");
                setAlumnos(null);
                setAviso(true);
            }

            setConfirmScanner(false);
        });
        setLoading(false);
    }

    const handleSubmit_tutor = (e) => {
        e.preventDefault();

        setErrors_NuevoTutor(validationsFrom_NuevoTutor(tutor));

        if (Object.keys(validationsFrom_NuevoTutor(tutor)).length === 0) {

            if (tutor.nombre && tutor.apellido1) {

                const arrUser = {
                    "opcion": "C",
                    "IdTipoTutor": 0,
                    "IdTutor": 0,
                    "Nombre": tutor.nombre,
                    "ApellidoPaterno": tutor.apellido1,
                    "ApellidoMaterno": tutor.apellido2,
                    "NombreTutor": "",
                    "NombreCompletoTutor": "",
                    "Telefono": "",
                    "Correo": "",
                    "Celular": "",
                    "Curp": "",
                    "TipoTutor": "",
                    "TelEmergencia": "",
                    "IdUsuario": storage.get('id'),
                    "IdAlumno": alumnoId,
                    "ParametrosExtra": `[{"IdTipoTutor": ${tutor.idTipoTutor}, "IdUsuario": ${storage.get("id")}, "IdAlumno": ${alumnoId}}]`
                }

                setLoading(true);

                helpHttp().post(`${BASE_API}Entrega/posSpdTutorActualizar`, {
                    body: arrUser,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    },
                }).then((res) => {
                    if (res.SUCCESS) {
                        let rtutor = res.Respuesta;
                        carga(cupu);

                        setTutor(initialFormNuevoTutor);
                    } else {

                    }
                    modalonhiden()
                });
                //setLoading(false);
            }

        } else {
            console.log("(3) Error en la validación de campos");
            return;
        }
    }

    const handleSubmit_tutor2 = (e) => {
        e.preventDefault();

        setErrors_NuevoTutor(validationsFrom_NuevoTutor(tutor));

        if (Object.keys(validationsFrom_NuevoTutor(tutor)).length === 0) {

            if (tutor.nombre && tutor.apellido1) {

                const arrUser = {
                    "opcion": "C",
                    "IdTipoTutor": 0,
                    "IdTutor": 0,
                    "Nombre": tutor.nombre,
                    "ApellidoPaterno": tutor.apellido1,
                    "ApellidoMaterno": tutor.apellido2,
                    "NombreTutor": "",
                    "NombreCompletoTutor": "",
                    "Telefono": "",
                    "Correo": "",
                    "Celular": "",
                    "Curp": "",
                    "TipoTutor": "",
                    "TelEmergencia": "",
                    "IdUsuario": storage.get('id'),
                    "IdAlumno": alumnoId,
                    "ParametrosExtra": `[{"IdTipoTutor": ${tutor.idTipoTutor}, "IdUsuario": ${storage.get("id")}, "IdAlumno": ${alumnoId}}]`
                }

                setLoading(true);

                helpHttp().post(`${BASE_API}Entrega/posSpdTutorActualizar`, {
                    body: arrUser,
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    },
                }).then((res) => {
                    if (res.SUCCESS) {
                        let nuevoTutor = { ...res.ITEMS, NombreTutor: `${res.ITEMS.ApellidoPaterno.trim()} ${res.ITEMS.ApellidoMaterno.trim()} ${res.ITEMS.Nombre.trim()}` }
                        dataMulti.forEach(x => {
                            x.lstTutor.push(nuevoTutor)
                        })
                        storage.set('alumnosMulti', dataMulti)
                        setDataMulti(dataMulti)
                        setTutor(initialFormNuevoTutor);
                    } else {

                    }
                    modalonhiden2()
                });
                setLoading(false);
            }

        } else {
            console.log("(3) Error en la validación de campos");
            return;
        }
    }

    const handleFind_tutores_x_alumno = (IdAlumno) => {

        const arrAlumno = {
            "IdAlumno": IdAlumno
        }

        helpHttp().post(`${BASE_API}BusquedaAlumnos/BuscarTutor`, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then((res) => {
            let arrTutores = res;
            if (arrTutores?.length > 0) {
                setTutores(arrTutores);
                setIdAlumno(IdAlumno);

                //console.log("arrTutores: " + arrTutores);
            } else {
                //setMessage("No se encontraron tutores para este alumno");
                setTutores(false);
                //setIdAlumno(null);
            }
        });
    }

    const obtenerDetEntrega = async (id) => {
        return await helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
            body: {
                sp: 'SpdConsultarEncEntrega',
                opcion: 2,
                parametros: [
                    { IdDetEntrega: id },
                    { IdCicloEscolar: ciclo.IdCicloEscolar }
                ]
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => res.ITEMS[0].idencentrega)
    }

    const handlerAssign_pendientes = () => {
        const arrAlumno = {
            "IdEncEntrega": 0,
            "IdTienda": storage.get('IdTienda'),
            "IdUsuario": storage.get('id'),
            "IdTutor": IdTutor,
            "Latitud": "29.08302909546271",
            "Longitud": "-110.99936963148365",
            "IdEstatus": 1,
            "alumnosId": [
                IdAlumno
            ],
            "OtroMotivoCancelacion": "",
            "IdAlumno": IdAlumno,
            "IdDocumento": 0,
            "IdCicloEscolar": ciclo.IdCicloEscolar
        }

        setLoading(true);


        helpHttp().post(`${BASE_API}Entrega/AgregarAListaEspera`, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(async (res) => {
            if (res.Id > 0) {
                const idDetEntrega = await obtenerDetEntrega(res.Id)
                helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                    body: {
                        sp: "SpdAgregarMovimientoUsuario",
                        tipo: 2,
                        parametros: [
                            { IdUsuario: idUsuario },
                            { IdTienda: idTienda },
                            { IdEtapa: 5 },
                            { IdEncEntrega: JSON.stringify([idDetEntrega]) },
                            { IdAlumno: JSON.stringify([IdAlumno]) },
                            { IdCicloEscolar: ciclo.IdCicloEscolar },
                            { ParametrosExtra: "" },
                        ]
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(response => {
                    if (response.SUCCESS) {
                        if (response.ITEMS.ErrorNumber === 0) {
                            // navigate("/pendientes"); //Funcion deshabilitada
                            //setRedirect(true);
                            //handlerRedirect();
                            //setMessage("Alumno enviado a la lista de pendientes");
                            //setAviso(false);
                            setDisplayConfirmation(false);
                            if (banderaEscaner === true) {
                                setConfirmScanner(true);
                            }
                        }
                    } else {
                        setDisplayConfirmation(false)
                        setMessage("Fallo en conexión, intente de nuevo.");
                        setAviso(true);
                    }
                }).catch(error => {
                    console.warn(error);
                    setDisplayConfirmation(false)
                    setMessage("Fallo en conexión, intente de nuevo.");
                    setAviso(true);
                })
            } else if (res.Id == 0) {
                setDisplayConfirmation(false)
                setMessage(res.MsgError);
                setAviso(true);
            } else {
                setDisplayConfirmation(false)
                setMessage('Error de conexión, Favor de iniciar el proceso nuevamente');
                setAviso(true);
            }
            setLista(false);
            setLoading(false);
        });
    }

    const handlerAssign_pendientesMulti = () => { //asignar a la lista de pendientes a los alumnos para multientrega

        console.log(checkboxValue[0])

        const arrAlumno = {
            "IdEncEntrega": 0,
            "IdTienda": storage.get('IdTienda'),
            "IdUsuario": storage.get('id'),
            "IdTutor": checkboxValue[0],
            "Latitud": "29.08302909546271",
            "Longitud": "-110.99936963148365",
            "IdEstatus": 1,
            "alumnosId": dataMulti.map(alumno => alumno.IdAlumno),
            "OtroMotivoCancelacion": "",
            "IdAlumno": null,
            "IdDocumento": 0,
            "IdCicloEscolar": ciclo.IdCicloEscolar
        }

        setLoading(true);


        helpHttp().post(`${BASE_API}Entrega/AgregarAListaEspera`, {
            body: arrAlumno,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            },
        }).then(async (res) => {
            if (res.Id > 0) {
                const idDetEntrega = await obtenerDetEntrega(res.Id)
                helpHttp().post(`${BASE_API}Dinamico/ConsultaDinamica`, {
                    body: {
                        sp: "SpdAgregarMovimientoUsuario",
                        tipo: 2,
                        parametros: [
                            { IdUsuario: idUsuario },
                            { IdTienda: idTienda },
                            { IdEtapa: 5 },
                            { IdEncEntrega: JSON.stringify([idDetEntrega]) },
                            { IdAlumno: JSON.stringify(dataMulti.map(alumno => alumno.IdAlumno)) },
                            { IdCicloEscolar: ciclo.IdCicloEscolar },
                            { ParametrosExtra: "" },
                        ]
                    },
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(response => {
                    if (response.SUCCESS) {
                        if (response.ITEMS.ErrorNumber === 0) {
                            // navigate("/pendientes");
                            //setRedirect(true);
                            //handlerRedirect();
                            //setMessage("Alumno enviado a la lista de pendientes");
                            setDisplayConfirmationMulti(false);
                            window.sessionStorage.removeItem('alumnosMulti')
                            setDataMulti([])
                            setFolio({ folio: "" })
                        }
                    } else {
                        setDisplayConfirmation(false)
                        setMessage("Fallo en conexión, intente de nuevo.");
                        setAviso(true);
                    }
                }).catch(error => {
                    console.warn(error);
                    setDisplayConfirmation(false)
                    setMessage("Fallo en conexión, intente de nuevo.");
                    setAviso(true);
                })
            } else if (res.Id == 0) {
                setDisplayConfirmation(false)
                setMessage(res.MsgError);
                setAviso(true);
            } else {
                setDisplayConfirmation(false)
                setMessage('Error de conexión, Favor de iniciar el proceso nuevamente');
                setAviso(true);
            }
            setCheckboxValue([])
            setLoading(false);
        });
    }

    // por folio
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFolio({
            ...folio,
            [name]: value,
        });
    };

    // por folio
    const handleBlur = (e) => {
        handleChange(e);
        setErrors(validationsFromFolio(folio));
    };

    // por data alumno
    const handleChangeData = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value,
        });
    };

    // por data alumno
    const handleBlurData = (e) => {
        handleChangeData(e);
        setDataErrors(validationsFromData(data));
    };

    // por tutor
    const handleChange_NuevoTutor = (e) => {
        const { name, value } = e.target;
        setTutor({
            ...tutor,
            [name]: value,
        });
    };

    // por tutor
    const handleBlur_NuevoTutor = (e) => {
        handleChange_NuevoTutor(e);
        setErrors_NuevoTutor(validationsFrom_NuevoTutor(tutor));
    };

    const modalonhiden = () => {
        setFormAdd_tutor(false)
        setLista(true)
        setErrors_NuevoTutor(true);
        setTutor(initialFormNuevoTutor)
    }

    const modalonhiden2 = () => {
        setFormAdd_tutor2(false);
        setDialogTutoresMulti(true);
        setErrors_NuevoTutor(true);
        setTutor(initialFormNuevoTutor);
    }

    /*const leftToolbarTemplate = () => {
        return (
            <form onSubmit={handleFind_alumno_folio}>
                <div className="formgroup-inline">
                    <div className="field">
                        <label htmlFor="folio" className="p-sr-only">CUPU:</label>
                        <InputText id="folio" name='folio' type="text" placeholder="folio" className={`w-full mb-3 ${errors.folio && 'p-invalid'}`} />
                        {errors.folio && <small className="p-error">{errors.folio}</small>}
                    </div>
                    {loading && <Loader />}
                    <Button type='submit' disabled={loading} label="Buscar"></Button>
                </div>

                <div className='text-center col-12'>
                    <div className="flex align-items-center justify-content-center">
                        <input placeholder="FOLIO" id="folio" name='folio' type="text" value={folio.folio} onChange={handleChange} onBlur={handleBlur} autoFocus className="p-inputtext p-component p-3 border-noround border-round-left" style={{"minWidth": "250px"}} />
                        <button className="p-button p-component border-noround border-round-right p-3 w-auto p-button-icon-only">
                            <span className="p-button-icon p-c pi pi-search"></span>
                            <span className="p-button-label p-c">&nbsp;</span>
                            <span role="presentation" className="p-ink" style={{"height": "55px", "width": "55px", "top": "-2.5px", "left": "-26.5px"}}></span>
                        </button>
                    </div>
                </div>

                <div className="col-12 md:col-12">
                    <div className="p-inputgroup">
                        <InputText placeholder="Keyword" />
                        <Button label="Search" />
                    </div>
                </div>

            </form>
        )
    }*/

    const confirmationDialogFooter = (
        <>
            <div className="flex pt-3" style={{ justifyContent: 'right' }}>
                <div>
                    <Button label='No' icon='pi pi-times' disabled={loading} className="p-button-outlined ml-3" onClick={() => {
                        setDisplayConfirmation(false);
                        if (banderaEscaner === true) {
                            setConfirmScanner(true);
                        }
                    }}>
                        {/* <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span> */}
                    </Button>
                </div>
                <div>
                    <Button label='Sí' icon='pi pi-check' disabled={loading} className="p-button ml-3" onClick={() => handlerAssign_pendientes()}>
                        {/* <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span> */}
                    </Button>
                </div>
            </div>
        </>
    );

    const confirmation2DialogFooter = (
        <>
            <div className="flex pt-3" style={{ justifyContent: 'right' }}>
                <div>
                    <Button label='No' icon='pi pi-times' disabled={loading} className="p-button-outlined ml-3" onClick={() => setDisplayConfirmation2(!displayConfirmation2)}>
                        {/* <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span> */}
                    </Button>
                </div>
                <div>
                    <Button label='Sí' icon='pi pi-check' disabled={loading} className="p-button ml-3" onClick={() => { setDisplayConfirmation(true); setDisplayConfirmation2(false); }}>
                        {/* <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span> */}
                    </Button>
                </div>
            </div>
        </>
    );
    const confirmationDialogFooterMulti = (
        <>
            <div className="flex pt-3" style={{ justifyContent: 'right' }}>
                <div>
                    <Button label='No' icon='pi pi-times' disabled={loading} className="p-button-outlined ml-3" onClick={() => {
                        setDisplayConfirmationMulti(!displayConfirmationMulti);
                        setCheckboxValue([])
                    }} />
                </div>
                <div>
                    <Button label='Sí' icon='pi pi-check' disabled={loading} className="p-button ml-3" onClick={() => handlerAssign_pendientesMulti()} />
                </div>
            </div>
        </>
    );

    const handleClear_alumno_x_data = () => {
        setData(initialFormData);
    }

    const basicDialogFooter = <React.Fragment>
        {/* <Button type="button" label="Aceptar" onClick={() => handlerRedirect()} icon="pi pi-check" className="p-button" /> */}
        {botonY !== false && (perfil === 3 || perfil === 19 || perfil === 1) && <Button type='button' loading={loadingYoremia} label="Obtener info." onClick={() => banderaGeneral !== true ? consultaYoremia(alumnoY) : consultaYoremiaGeneral(alumnoY)} />}
    </React.Fragment>;

    const handleScanner = () => {
        setConfirmScanner(true);
        setBanderaEscaner(true);
    };
    const descargarVale = (Alumno) => {
        setLoadingVale(true)
        helpHttp().post(`${BASE_API}Reportes/postObtenerReporte`, {
            body: {
                reporte: 12,
                CURP: Alumno.Curp,
                sistema: true,
                CicloEscolar: ciclo.Descripcion.split('(')[0].trim(),
                parametrosExtra: `[{ 'IdCicloEscolar': ${ciclo.IdCicloEscolar}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.ITEMS.idEstatus !== 5) {
                const linkSource = `data:application/pdf;base64,${res.ITEMS.objResultado}`;
                const downloadLink = document.createElement("a");
                const fileName = `${Alumno.CUPU}_${Alumno.Curp}_Ciclo_${ciclo.IdCicloEscolar}.pdf`

                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                setAviso(true);
                setMessage(res.ITEMS.Estatus);
            }

            setLoadingVale(false)
        })
    }

    const handleAgregarAlumnoMulti = (alumno) => {
        const _dataMulti = [...dataMulti];
        let valida = dataMulti.some(x => x.CUPU !== alumno.CUPU);

        if (valida || dataMulti.length === 0) {
            _dataMulti.push(alumno)
            storage.set('alumnosMulti', _dataMulti)
            setDataMulti(_dataMulti)
        }
        setLista(false);
        if (banderaEscaner === true) {
            setConfirmScanner(true);
        }
    }

    const handleRetiraralumnoMulti = (alumno) => {
        const _dataMulti = dataMulti.filter((val) => val.CUPU !== alumno.CUPU);
        storage.set('alumnosMulti', _dataMulti)
        setDataMulti(_dataMulti)
    }

    const openTutorMulti = () => {
        setDialogTutoresMulti(true)
    }

    const TutoresMultiFooter = () => {
        return <React.Fragment>
            <div className='col-12 flex'>
                <div className='col-6 text-left'>
                    <Button className='p-button-outlined' label='Agregar tutor' onClick={() => handleShowForm_NuevoTurtor2(dataMulti[0].IdAlumno, dataMulti[0].CUPU)} />
                </div>
                <div className='col-6 text-right'>
                    <Button className='p-button-outlined' label='Cancelar' onClick={() => { setDialogTutoresMulti(!dialogTutoresMulti); setCheckboxValue([]) }} />
                    <Button className='p-button' label='Guardar' onClick={handleConfirmationMulti} /*onClick={handlerAssign_pendientesMulti}*/ />
                </div>
            </div>

        </React.Fragment>
    }

    const templateAlumnosMulti = (alumno) => {
        return (
            <div className="col-12">
                <div className="grid">
                    <div className="col-9 pl-0 pr-0 lg:flex">
                        <div className="col-12 lg:col-2 text-l text-900 mr-1 pb-0 block lx:hidden lg:hidden md:hidden sm:block xs:block">• {alumno.CUPU}</div>
                        <div className="col-12 lg:col-10 text-l text-900 pt-0 pr-0 block lx:hidden lg:hidden md:hidden sm:block xs:block">{alumno.NombreAlumno}</div>

                        <div className="col-12 lg:col-10 text-l text-900 hidden lx:block lg:block md:block sm:hidden xs:hidden">• {alumno.CUPU} {alumno.NombreAlumno}</div>

                    </div>
                    <div className='col-3 pr-0 pl-0 text-center xl:text-right lg:text-right md:text-right sm:text-center xs:text-center align-content-center'>
                        <Button rounded className='p-button-outlined' icon='pi pi-trash' tooltip='Retirar alumno' onClick={() => handleRetiraralumnoMulti(alumno)} />
                    </div>
                </div>
            </div>
        );
    }

    const onCheckboxChange = (e) => {
        console.log(e.value)
        if (e.checked) {
            setCheckboxValue([e.value]);
        } else {
            setCheckboxValue([]);
        }
    };

    const ListaTutores = (lstAlumnos) => {
        if (lstAlumnos.length > 0) {
            lstAlumnos.forEach(x => {
                x.lstTutor.forEach(j => {
                    tempTutores.push(j)
                })
            })

            return [... new Set(tempTutores.map(x => x))]
        }
    }

    const AbrirConfirmacion = (alumno) => {
        setAlumno(alumno)
        setDisplayConfirmation3(true);
    }

    const confirmationDialogFooter3 = (
        <>
            <div className="flex pt-3" style={{ justifyContent: 'right' }}>
                <div>
                    <Button label='No' icon='pi pi-times' disabled={loading} className="p-button-outlined ml-3" onClick={() => setDisplayConfirmation3(false)}>
                        {/* <span className="p-button-icon p-c pi pi-times-circle">&nbsp;NO</span>
                        <span className="p-button-label p-c">&nbsp;</span> */}
                    </Button>
                </div>
                <div>
                    <Button label='Sí' icon='pi pi-check' disabled={loading} className="p-button ml-3" onClick={() => EntregaParcial(alumno)}>
                        {/* <span className="p-button-icon p-c pi pi-check-circle">&nbsp;SI</span>
                        <span className="p-button-label p-c">&nbsp;</span> */}
                    </Button>
                </div>
            </div>
        </>
    );

    const isValidResponse = (data) => {
        return data && (data.success !== false || data.success === undefined)
    }

    const consultaYoremiaGeneral = async (alumno) => {
        setLoadingYoremia(true)
        if (alumno.IdNivel !== 0) {
            helpHttp().post(`${BASE_API}Login/busquedaYoremia`, {
                body: {
                    "nivel": alumno.IdNivel,
                    "nombre": alumno.nombre.trim(),
                    "curp": alumno.Curp
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.success || res.success === undefined) {
                    setDataY(res.data.data[0])
                    botonY !== false ? setAviso(false) : setLista(false)
                    setAvisoY(true)
                } else {
                    //setMessageY(res.message)
                    setMessageY('Sin información del alumno en Yoremia. Intente seleccionando otro nivel.')
                    botonY !== false ? setAviso(false) : setLista(false)
                    setAvisoY(true);
                }
                setBanderaGeneral(false);
                setLoadingYoremia(false)
            }).catch(err => {
                setMessageY("Error interno del servidor. Intente de nuevo.")
                botonY !== false ? setAviso(false) : setLista(false)
                setAvisoY(true)
                setLoadingYoremia(false)
                setBanderaGeneral(false);
            })
        } else {
            const niveles = getNivel.filter(x => x.code !== 0);

            try {
                for (const nivel of niveles) {
                    try {
                        const response = await helpHttp().post(`${BASE_API}Login/busquedaYoremia`, {
                            body: {
                                "nivel": nivel.code,
                                "nombre": alumno.nombre.trim(),
                                "curp": alumno.Curp
                            },
                            headers: {
                                "Content-Type": "application/json; charset=utf-8",
                                "Accept": "application/json",
                                'Authorization': `Bearer ${storage.get('token')}`
                            }
                        })

                        if (isValidResponse(response)) {
                            setDataY(response.data.data[0])
                            botonY !== false ? setAviso(false) : setLista(false)
                            setAvisoY(true);
                            return;
                        }
                    } catch (err) {
                        console.error(err)
                    }
                }

                //setMessageY(res.message)
                setMessageY('Sin información del alumno en Yoremia. Intente seleccionando otro nivel.')
                botonY !== false ? setAviso(false) : setLista(false)
                setAvisoY(true);

            } catch (err) {
                console.error(err)
            } finally {
                setBanderaGeneral(false);
                setLoadingYoremia(false);
            }

        }
    }

    const consultaYoremia = (alumno) => {
        setLoadingYoremia(true)
        helpHttp().post(`${BASE_API}Login/busquedaYoremia`, {
            body: {
                "nivel": alumno.IdNivel,
                "nombre": "",
                "curp": alumno.Curp
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.success || res.success === undefined) {
                setDataY(res.data.data[0])
                botonY !== false ? setAviso(false) : setLista(false)
                setAvisoY(true)
            } else {
                //setMessageY(res.message)
                setMessageY('Sin información del alumno en Yoremia.')
                botonY !== false ? setAviso(false) : setLista(false)
                setAvisoY(true)
            }
            setLoadingYoremia(false)
            setBanderaGeneral(false);
        }).catch(err => {
            setMessageY("Error interno del servidor. Intente de nuevo.")
            botonY !== false ? setAviso(false) : setLista(false)
            setAvisoY(true)
            setLoadingYoremia(false)
            setBanderaGeneral(false);
        })
    }

    const EntregaParcial = (alumno) => {
        setLoading(true)
        const date = new Date()
        const prendas = JSON.parse(JSON.parse(alumno.TipoVale)[0].PrendaElegida).filter(prenda => prenda.Entregado === false).map(x => ({
            IdAlumno: alumno.IdAlumno,
            IdPrenda: x.IdPrenda,
            IdTalla: x.IdTalla,
            Activo: 1,
            Entregado: true,
            SerieEntregado: "0000000"
        }))
        const entrega = {
            IdEncEntrega: 0,
            IdAlumno: alumno.IdAlumno,
            IdUsuarioModificacion: storage.get('id'),
            FechaModificacion: date.toISOString(),
            IdEstatus: 2,
            TablaPrenda: prendas,
            IdCicloEscolar: ciclo.IdCicloEscolar
        }
        // console.log(entrega)
        console.log(entrega)
        helpHttp().post(`${BASE_API}Entrega/ConfirmarEntregaParcial`, {
            body: entrega,
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                navigate(`/resumen/${window.btoa(alumno.IdAlumno)}`)
            }
            setLoading(false)
        })
    }

    const onHideY = () => {
        setAvisoY(false);
        setMessageY(false);
        setDataY(false);
        botonY !== false ? setAviso(true) : setLista(true);
    }

    return (
        <>
            <Permiso perfil={5} />

            <Menu link='filtro' />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <form onSubmit={handleFind_alumno_folio} className="surface-section p-5 md:p-12 lg:p-12" name='form-folio' id="form-folio">
                            <div className="lg:align-items-start lg:flex-row border-round" style={{ background: '#f3f3f3', border: '1px solid #dee2e6' }}>
                                <div className="col-12 md:col-12">

                                    <div className='col-12 lg:col-12 md:col-12 sm:col-11 xs:col-1 lg:flex' style={{ paddingBottom: '0' }}>
                                        <div className='col-12 lg:col-10 flex'>
                                            <span className="p-input-icon-left w-full">
                                                <i className="pi pi-search" />
                                                <InputText id="folio" name='folio' type="text" placeholder="Buscador por cupu" value={folio.folio} onChange={handleChange} onBlur={handleBlur} className={`${errors.folio && 'p-invalid'} w-full`} autoFocus />
                                            </span>
                                        </div>
                                        <div className='col-12 lg:col-1 text-center'>
                                            <Button className='p-button w-full' type='submit' name="button-folio" id="button-folio" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : '')} label="Buscar" />
                                        </div>
                                        <div className='col-12 lg:col-1 text-center'>
                                            <Button className='p-button w-full mr-2 mb-2' label="Escanear" type='button' icon="pi pi-qrcode" onClick={handleScanner}></Button>
                                        </div>
                                        {/* <div className='col-2 lg:col-1 md:col-1 sm:col-2 text-center'>
                                            <Button label="Escanear" type='button' icon="pi pi-qrcode" className="mr-2 mb-2" onClick={handleScanner}></Button>
                                        </div> */}
                                    </div>

                                    {errors.folio && <small className="p-error" style={{ marginLeft: '15px' }}>{errors.folio}</small>}

                                </div>
                            </div>
                        </form>

                        <div className="surface-section md:p-12 lg:p-12" style={{ paddingLeft: '25px', paddingRight: '25px', paddingBottom: '25px' }}>
                            <div className="flex lg:align-items-start flex-column lg:flex-row border-round border-1" style={{ border: '1px solid #cfcfcf', paddingTop: '5px', background: '#ffffff !important' }}>
                                <div className="col-12 md:col-12">
                                    <div className='col-12'>
                                        <h6 style={{ color: '#9b2f3e' }}>LISTADO MULTIENTREGA</h6>
                                        <DataScroller id='multientregaDataScroller' value={dataMulti} emptyMessage='No hay registros' itemTemplate={templateAlumnosMulti} rows={3} inline scrollHeight="150px" />
                                        {dataMulti.length > 0 &&
                                            <div className='text-right mt-3'>
                                                <Button className='p-button' label='Terminar multientrega' onClick={openTutorMulti} />
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="surface-section p-2 md:p-12 lg:p-12">
                            <div className="flex lg:align-items-start flex-column lg:flex-row p-4 bg-gray-100 border-round border-1 border-gray-200">
                                <div className="col-12 md:col-12">
                                    <div id="reader"></div>
                                </div>
                            </div>
                        /div> */}

                        <TabView id='panelEstudiante'>
                            <TabPanel header="ESTUDIANTE">
                                <form onSubmit={handleFind_alumno_x_data} className="p-fluid" name="data" id="data">
                                    <div className="p-fluid formgrid grid mb-4">
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="curp">CURP:</label>
                                            <InputText id="curp" name="curp" type="text" value={data.curp} className={`w-full mb-3 ${dataErrors.curp && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.curp && <small className="p-error">{dataErrors.curp}</small>}
                                        </div>

                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="nombre">Nombre:</label>
                                            <InputText id="nombre" name="nombre" type="text" value={data.nombre} className={`w-full mb-3 ${dataErrors.nombre && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.nombre && <small className="p-error">{dataErrors.nombre}</small>}
                                        </div>

                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="apellido_paterno">Apellido paterno:</label>
                                            <InputText id="apellido_paterno" name="apellido_paterno" type="text" value={data.apellido_paterno} className={`w-full mb-3 ${dataErrors.apellido_paterno && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.apellido_paterno && <small className="p-error">{dataErrors.apellido_paterno}</small>}
                                        </div>

                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="apellido_materno">Apellido materno:</label>
                                            <InputText id="apellido_materno" name="apellido_materno" type="text" value={data.apellido_materno} className={`w-full mb-3 ${dataErrors.apellido_materno && 'p-invalid'}`} onChange={handleChangeData} onBlur={handleBlurData} />
                                            {dataErrors.apellido_materno && <small className="p-error">{dataErrors.apellido_materno}</small>}
                                        </div>
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="nivel">Nivel:</label>
                                            <Dropdown id='nivel' name='nivel' value={data.nivel} options={getNivel} optionLabel='name' optionValue='code' onChange={handleChangeData} className={`w-full mb-3 ${dataErrors.nivel && 'p-invalid'}`} />
                                            {dataErrors.nivel && <small className="p-error">{dataErrors.nivel}</small>}
                                        </div>

                                        <div className="field col-12 md:col-12">
                                            <div className="border-top-1 surface-border pt-3 flex">
                                                <button type="button" aria-label="Borrar" className="p-button p-component p-button-outlined w-6 mr-2" onClick={() => handleClear_alumno_x_data()}>
                                                    <span className="p-button-label p-c">Borrar</span><span role="presentation" className="p-ink"></span>
                                                </button>

                                                <Button type='submit' label="Buscar" name="button-data" id="button-data" loading={dataLoading} className="p-button p-component w-6 ml-2">
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </TabPanel>
                            {/*<TabPanel header="TUTOR">
                                <div className="p-fluid">
                                    <div className="p-fluid formgrid grid mb-4">
                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="nombre">Nombre:</label>
                                            <InputText id="nombre" name="nombre" value="" />
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="apellido_paterno">Apellido Paterno:</label>
                                            <InputText id="apellido_paterno" name="apellido_paterno" value="" />
                                        </div>

                                        <div className="field col-12 md:col-4">
                                            <label htmlFor="apellido_materno">Apellido Materno:</label>
                                            <InputText id="apellido_materno" name="apellido_materno" value="" />
                                        </div>

                                        <div className="field col-12 md:col-12">
                                            <div className=" border-top-1 surface-border pt-3 flex">
                                                <button aria-label="Borrar" className="p-button p-component p-button-outlined w-6 mr-2">
                                                    <span className="p-button-label p-c">Borrar</span><span role="presentation" className="p-ink"></span>
                                                </button>

                                                <button aria-label="Buscar" className="p-button p-component w-6 ml-2">
                                                    <span className="p-button-label p-c">Buscar</span><span role="presentation" className="p-ink"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>*/}
                        </TabView>
                    </div>
                </div>
            </div>

            <Dialog header="ALUMNO" id='modalCancelacion' resizable={false} draggable={false} visible={lista} style={{ width: '95%' }} modal onHide={() => {
                setLista(false);
                if (banderaEscaner === true) {
                    setConfirmScanner(true);
                }
            }}>
                <div className="grid">
                    {alumnos && alumnos.map((el, index) =>
                        <div className="col-12 lg:col-12 p-3 shadow-5 surface-card" key={index} style={{ marginBottom: '10px' }}>
                            <div className="p-3 border-round  flex align-items-center">
                                <div className="inline-flex align-items-center justify-content-center mr-3" style={{ 'width': ' 48px', 'height': '48px', 'borderRadius': '25px', border: 'solid 1px #9B2F3E' }}>
                                    <i className={`pi ${(el.IdEstatus === 2 ? 'pi-lock' : 'pi-lock-open')} text-3xl`} style={{ color: '#9B2F3E' }}></i>
                                </div>
                                <div>
                                    <span className="text-900 text-xl font-medium mb-3">{el.CUPU} - {el.NombreCompleto}</span>
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">CURP: <strong>{el.Curp}</strong></p>
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">ESCUELA: <strong>{el.Codigo} "{el.Escuela}" </strong></p>
                                    <p className="mt-1 mb-0 text-600 font-medium text-sm">CICLO ESCOLAR: <strong>{el.CicloEscolar}</strong></p>
                                </div>
                                <div className="ml-auto">
                                    {(el.IdEstatus === 1
                                        ?
                                        (perfil === 13 || perfil === 16 || perfil === 1 ?
                                            <>
                                                <Button icon="pi pi-plus" label="Agregar tutor" style={{ marginLeft: '10px', marginBottom: '10px' }}
                                                    disabled={
                                                        perfil === 16 ? true
                                                            :
                                                            ciclo.Activo === false ? true : (JSON.parse(el.TipoVale)[0].agregar === 0 ? true : JSON.parse(el.TipoVale)[0].idProcede === 2 ? true : false)
                                                    }
                                                    onClick={() => handleShowForm_NuevoTurtor(el.IdAlumno, el.CUPU)} ></Button>
                                                <Button className='p-button' icon='pi pi-plus' label='Multientrega' style={{ marginLeft: '10px', marginBottom: '10px' }}
                                                    disabled={
                                                        perfil === 16 ? true
                                                            :
                                                            ciclo.Activo === false ? true : (JSON.parse(el.TipoVale)[0].agregar !== 0 ? JSON.parse(el.TipoVale)[0].idProcede !== 2 ? dataMulti.length > 0 && dataMulti.some(x => x.CUPU === el.CUPU) : true : true)
                                                    }
                                                    onClick={() => handleAgregarAlumnoMulti(el)} />
                                            </> : "")
                                        :

                                        <>
                                            {/*<Button label="Hacer Cambio" icon="pi pi-sync" onClick={() => navigate(`/cambios/${el.IdAlumno}`) }></Button>&nbsp;*/}
                                            {el.IdEstatus === 6 &&
                                                <Button label="Terminar entrega" icon="pi pi-check" style={{ marginLeft: '10px', marginBottom: '10px' }}
                                                    disabled={
                                                        perfil === 16 ? true
                                                            :
                                                            ciclo.Activo === false ? true : false
                                                    }
                                                    onClick={() => AbrirConfirmacion(el)}></Button>
                                            }
                                            <Button label="Ver Detalle" icon="pi pi-bars" style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => navigate(`/resumen/${window.btoa(el.IdAlumno)}`)}></Button>
                                        </>
                                    )}
                                    {/* <Button className='p-button' icon='pi pi-plus' label='Multientrega' style={{ marginBottom: '10px' }} onClick={() => handleAgregarAlumnoMulti(el)} /> */}
                                    <Button className='p-button' icon="pi pi-download" label="Descargar vale" style={{ marginLeft: '10px', marginBottom: '10px' }}
                                        disabled={
                                            perfil === 16 ? true
                                                :
                                                ciclo.Activo === false ? true : false
                                        }
                                        loading={loadingVale} onClick={() => descargarVale(el)} />

                                    {(perfil === 3 || perfil === 19 || perfil === 1) &&
                                        <Button loading={loadingYoremia} label="Obtener info." style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => consultaYoremia(el)} />
                                    }
                                </div>
                            </div>
                            {(parseInt(el.IdEstatus) === 1
                                ?
                                (JSON.parse(el.TipoVale)[0].idProcede > 0 ?
                                    (el.lstTutor.length > 0
                                        ?
                                        <>
                                            <div>
                                                {/*    <div className='col-12 text-center' style={{ paddingBottom: 0 }}>
                                                    <h6 className="bg-gray" style={{ textAlign: 'center', marginTop: '-23px', background: '#ffffff', width: '175px' }}>Prendas del alumno</h6>
                                                </div> */}
                                                <div className='col-12'>
                                                    <ul>
                                                        {JSON.parse(JSON.parse(el.TipoVale)[0].PrendaElegida).map((prenda, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <div className='col-12 flex'>
                                                                        <Tooltip target=".custom-target-icon" />
                                                                        {/* <div className=' lg:mr-5 md:mr-5 col-12 lg:col-3 md:col-3' style={{ width: '97px', paddingLeft: 0, paddingRight: 0, alignSelf: 'center', fontWeight: '600', color: prenda.PrendaDisponible ? '#367755' : '#9b1919' }}>
                                                                            <label style={{ marginRight: '10px' }}>{prenda.PrendaDisponible == 1 ? 'Entregado' : 'No entregado'}</label>
                                                                        </div> */}
                                                                        <div className='col-6 lg:col-3'>
                                                                            <label><label className='font-semibold'>Prenda:</label> {prenda.Prenda}</label>
                                                                        </div>
                                                                        {/* <div className='col-3 lg:col-2'>
                                                                            <label><label className='font-semibold'>Género:</label> {prenda.Genero}</label>
                                                                        </div> */}
                                                                        <div className='col-6 lg:col-3'>
                                                                            <label><label className='font-semibold'>Talla:</label> {prenda.Talla}</label>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                            {JSON.parse(el.TipoVale)[0].agregar !== 0 && perfil !== 16 && perfil !== 19 && perfil !== 21 && perfil !== 3 && ciclo.Activo === true ?
                                                <>
                                                    <p className="text-700 font-medium mb-1">SELECCIONAR TUTOR</p>
                                                    {dataMulti.length > 0 && dataMulti.some(x => x.CUPU === el.CUPU) && <div className='mt-2'>
                                                        <div style={{ color: '#9b2f3e' }}><h6>Hay alumnos en la lista de multientrega.</h6></div>
                                                    </div>}
                                                    <div className="flex pt-3">
                                                        {
                                                            el.lstTutor.map((elle, indey) =>
                                                                <div className="w-6 pr-2" key={indey}>
                                                                    <button /*disabled={dataMulti.length > 0 ? true : false}*/ className="p-button p-component p-button-outlined p-button-secondary w-full p-button-icon-only" onClick={() => handleConfirmation(elle.IdTutor, el.IdAlumno, JSON.parse(el.TipoVale)[0])}>
                                                                        <span className="p-button-icon p-c pi pi-user"></span> <span>&nbsp; &nbsp;{elle.NombreTutor}</span>
                                                                        <span className="p-button-label p-c">&nbsp;</span>
                                                                    </button>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <div className='mt-2'>
                                                    <div style={{ color: '#9b2f3e' }}><h6>{JSON.parse(el.TipoVale)[0].mensaje}</h6></div>
                                                </div>
                                            }
                                        </>
                                        :
                                        <>
                                            <div className='col-12'>
                                                <ul>
                                                    {JSON.parse(JSON.parse(el.TipoVale)[0].PrendaElegida).map((prenda, index) => {
                                                        return (
                                                            <li key={index}>
                                                                <div className='col-12 flex'>
                                                                    <Tooltip target=".custom-target-icon" />
                                                                    {/* <div className=' lg:mr-5 md:mr-5 col-12 lg:col-3 md:col-3' style={{ width: '97px', paddingLeft: 0, paddingRight: 0, alignSelf: 'center', fontWeight: '600', color: prenda.PrendaDisponible ? '#367755' : '#9b1919' }}>
                                                                        <label style={{ marginRight: '10px' }}>{prenda.PrendaDisponible == 1 ? 'Entregado' : 'No entregado'}</label>
                                                                    </div> */}
                                                                    <div className='col-6 lg:col-3'>
                                                                        <label><label className='font-semibold'>Prenda:</label> {prenda.Prenda}</label>
                                                                    </div>
                                                                    {/*  <div className='col-3 lg:col-2'>
                                                                        <label><label className='font-semibold'>Género:</label> {prenda.Genero}</label>
                                                                    </div> */}
                                                                    <div className='col-6 lg:col-3'>
                                                                        <label><label className='font-semibold'>Talla:</label> {prenda.Talla}</label>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            {JSON.parse(el.TipoVale)[0].mensaje === "" ?
                                                JSON.parse(el.TipoVale)[0].agregar === 0 ?
                                                    JSON.parse(el.TipoVale)[0].idProcede !== 2 ?
                                                        dataMulti.length > 0 && dataMulti.some(x => x.CUPU === el.CUPU) &&
                                                        <div className='mt-2'>
                                                            <div style={{ color: '#9b2f3e' }}><h6>Hay alumnos en la lista de multientrega.</h6></div>
                                                        </div> :
                                                        <div style={{ color: '#9b2f3e' }} className='col-12'><h6>No es posible agregar tutor, por el momento no hay prendas disponibles.</h6></div> :
                                                    null :
                                                <div className='mt-2'>
                                                    <div style={{ color: '#9b2f3e' }}><h6>{JSON.parse(el.TipoVale)[0].mensaje}</h6></div>
                                                </div>
                                            }
                                            < MessageDetail color='warn' mensaje="DEBE AGREGAR TUTOR" />
                                        </>
                                    )
                                    :
                                    JSON.parse(el.TipoVale)[0].idProcede === 2 ?
                                        <div className='grid'>
                                            <div style={{ color: '#9b2f3e' }} className='col-12'><h6>No es posible agregar tutor, por el momento no hay prendas disponibles.</h6></div>
                                            <div className='col-12'>
                                                <ul>
                                                    {JSON.parse(JSON.parse(el.TipoVale)[0].PrendaElegida).map((prenda, index) => {
                                                        return (
                                                            <li key={index}>
                                                                <div className='col-12 flex'>
                                                                    <Tooltip target=".custom-target-icon" />
                                                                    {/* <div className=' lg:mr-5 md:mr-5 col-12 lg:col-3 md:col-3' style={{ width: '97px', paddingLeft: 0, paddingRight: 0, alignSelf: 'center', fontWeight: '600', color: prenda.PrendaDisponible ? '#367755' : '#9b1919' }}>
                                                                        <label style={{ marginRight: '10px' }}>{prenda.PrendaDisponible == 1 ? 'Entregado' : 'No entregado'}</label>
                                                                    </div> */}
                                                                    <div className='col-6 lg:col-3'>
                                                                        <label><label className='font-semibold'>Prenda:</label> {prenda.Prenda}</label>
                                                                    </div>
                                                                    {/* <div className='col-3 lg:col-2'>
                                                                        <label><label className='font-semibold'>Género:</label> {prenda.Genero}</label>
                                                                    </div> */}
                                                                    <div className='col-6 lg:col-3'>
                                                                        <label><label className='font-semibold'>Talla:</label> {prenda.Talla}</label>
                                                                    </div>

                                                                </div>

                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                        :
                                        <>
                                            {JSON.parse(el.TipoVale)[0].mensaje !== "" ?
                                                <div className='mt-2'>
                                                    <div style={{ color: '#9b2f3e' }}><h6>{JSON.parse(el.TipoVale)[0].mensaje}</h6></div>
                                                </div> :
                                                <div className='grid w-5'>
                                                    <div style={{ color: '#9b2f3e' }} className='col-12'><h6>No es posible agregar tutor, el alumno no cuenta con prendas.</h6></div>
                                                </div>
                                            }
                                        </>
                                )
                                :
                                (parseInt(el.IdEstatus) === 6 &&
                                    <div className='grid'>
                                        <div style={{ color: '#9b2f3e' }} className='col-12'><h6>{JSON.parse(el.TipoVale)[0].mensaje}</h6></div>
                                        <div className='col-12'>
                                            <ul>
                                                {JSON.parse(JSON.parse(el.TipoVale)[0].PrendaElegida).map((prenda, index) => {
                                                    return (
                                                        <li key={index}>
                                                            <div className='col-12 flex'>
                                                                <Tooltip target=".custom-target-icon" />
                                                                {/* <div className=' lg:mr-5 md:mr-5 col-12 lg:col-3 md:col-3' style={{ width: '97px', paddingLeft: 0, paddingRight: 0, alignSelf: 'center', fontWeight: '600', color: prenda.Entregado ? '#367755' : '#9b1919' }}>
                                                                    <label style={{ marginRight: '10px' }}>{prenda.Entregado == 1 ? 'Entregado' : 'No entregado'}</label>
                                                                </div> */}
                                                                <div className='col-6 lg:col-3'>
                                                                    <label><label className='font-semibold'>Prenda:</label> {prenda.Prenda}</label>
                                                                </div>
                                                                {/* <div className='col-3 lg:col-2'>
                                                                    <label><label className='font-semibold'>Género:</label> {prenda.Genero}</label>
                                                                </div> */}
                                                                <div className='col-6 lg:col-3'>
                                                                    <label><label className='font-semibold'>Talla:</label> {prenda.Talla}</label>
                                                                </div>

                                                            </div>


                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    )}
                </div>
            </Dialog>

            <Dialog header="AGREGAR TUTOR" id='modalCancelacion' blockScroll={true} resizable={false} draggable={false} visible={form_tutor} style={{ width: '95vw' }} modal onHide={modalonhiden}>
                <form onSubmit={handleSubmit_tutor} className="col-12">
                    <div className="row">
                        <label style={{ textAlign: 'right', color: 'red' }}>* Campos obligatorios</label>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="nombre"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Nombre(s):</label>
                                <InputText id="nombre" name="nombre" type="text" value={tutor.nombre} onChange={handleChange_NuevoTutor} autoFocus className={errors_nuevo_tutor.nombre && 'p-invalid'} />
                                {errors_nuevo_tutor.nombre && <small className="p-error">{errors_nuevo_tutor.nombre}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellido1"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Primer apellido:</label>
                                <InputText id="apellido1" name="apellido1" type="text" value={tutor.apellido1} onChange={handleChange_NuevoTutor} className={errors_nuevo_tutor.apellido1 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido1 && <small className="p-error">{errors_nuevo_tutor.apellido1}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellido2">Segundo apellido:</label>
                                <InputText id="apellido2" name="apellido2" type="text" value={tutor.apellido2} onChange={handleChange_NuevoTutor} className={errors_nuevo_tutor.apellido2 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido2 && <small className="p-error">{errors_nuevo_tutor.apellido2}</small>}
                            </div>

                            {/*  <div className="field col-12 md:col-6">
                                <label htmlFor="idTipoTutor"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Tipo tutor:</label>
                                <Dropdown id="idTipoTutor" name="idTipoTutor" placeholder='Selecciona' type="text" value={tutor.idTipoTutor} onChange={handleChange_NuevoTutor} options={lstTipoTutor} optionLabel='TipoTutor' optionValue='IdTipoTutor' className={errors_nuevo_tutor.idTipoTutor && 'p-invalid'} />
                                {errors_nuevo_tutor.idTipoTutor && <small className="p-error">{errors_nuevo_tutor.idTipoTutor}</small>}
                            </div> */}
                        </div>

                        <div className="px-4 py-3 surface-100 text-right">
                            {loading && <div><Loader /></div>}
                            <Button type="submit" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} value="Enviar" label="Guardar" className="mr" align="right"></Button>
                        </div>
                    </div>
                </form>
            </Dialog>

            <Dialog header="AGREGAR TUTOR" id='modalCancelacion' resizable={false} blockScroll={true} draggable={false} visible={form_tutor2} style={{ width: '95vw' }} modal onHide={modalonhiden2}>
                <form onSubmit={handleSubmit_tutor2} className="col-12">
                    <div className="row">
                        <label style={{ textAlign: 'right', color: 'red' }}>* Campos obligatorios</label>
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="nombre"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Nombre(s):</label>
                                <InputText id="nombre" name="nombre" type="text" value={tutor.nombre} onChange={handleChange_NuevoTutor} autoFocus className={errors_nuevo_tutor.nombre && 'p-invalid'} />
                                {errors_nuevo_tutor.nombre && <small className="p-error">{errors_nuevo_tutor.nombre}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellido1"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Primer apellido:</label>
                                <InputText id="apellido1" name="apellido1" type="text" value={tutor.apellido1} onChange={handleChange_NuevoTutor} className={errors_nuevo_tutor.apellido1 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido1 && <small className="p-error">{errors_nuevo_tutor.apellido1}</small>}
                            </div>

                            <div className="field col-12 md:col-6">
                                <label htmlFor="apellido2">Segundo apellido:</label>
                                <InputText id="apellido2" name="apellido2" type="text" value={tutor.apellido2} onChange={handleChange_NuevoTutor} className={errors_nuevo_tutor.apellido2 && 'p-invalid'} />
                                {errors_nuevo_tutor.apellido2 && <small className="p-error">{errors_nuevo_tutor.apellido2}</small>}
                            </div>

                            {/* <div className="field col-12 md:col-6">
                                <label htmlFor="idTipoTutor"><b style={{ marginRight: '5px', color: 'red' }}>*</b>Tipo tutor:</label>
                                <Dropdown id="idTipoTutor" name="idTipoTutor" placeholder='Selecciona' type="text" value={tutor.idTipoTutor} onChange={handleChange_NuevoTutor} options={lstTipoTutor} optionLabel='TipoTutor' optionValue='IdTipoTutor' className={errors_nuevo_tutor.idTipoTutor && 'p-invalid'} />
                                {errors_nuevo_tutor.idTipoTutor && <small className="p-error">{errors_nuevo_tutor.idTipoTutor}</small>}
                            </div> */}
                        </div>

                        <div className="px-4 py-3 surface-100 text-right">
                            {loading && <div><Loader /></div>}
                            <Button type="submit" disabled={loading} icon={(loading ? 'pi pi-spin pi-spinner' : 'pi pi-check')} value="Enviar" label="Guardar" className="mr" align="right"></Button>
                        </div>
                    </div>
                </form>
            </Dialog>

            <Dialog header="CONFIRMACIÓN" draggable={false} resizable={false} visible={displayConfirmation} closable={false} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Cuenta con identificación oficial?
                    </span>
                </div>
            </Dialog>

            <Dialog header="CONFIRMACIÓN" draggable={false} resizable={false} visible={displayConfirmation3} closable={false} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooter3}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Está seguro de finalizar la entrega?
                    </span>
                </div>
            </Dialog>

            <Dialog header="AVISO" draggable={false} resizable={false} visible={displayConfirmation2} closable={false} style={{ width: '400px' }} modal className="p-fluid" footer={confirmation2DialogFooter}>
                <div className="align-items-center text-center justify-content-center">
                    <span>Tiene {dataMulti.length} alumno(s) en la lista de multientrega.</span><br />
                    <span>¿Desea continuar?</span>
                </div>
            </Dialog>

            <Dialog header="CONFIRMACIÓN" draggable={false} resizable={false} visible={displayConfirmationMulti} closable={false} style={{ width: '400px' }} modal className="p-fluid" footer={confirmationDialogFooterMulti}>
                <div className="flex align-items-center justify-content-center">
                    <span>
                        ¿Cuenta con identificación oficial?
                    </span>
                </div>
            </Dialog>

            <Dialog header="AVISO" visible={aviso} draggable={false} resizable={false} closable={true} style={{ width: '400px' }} modal className="p-fluid" onHide={() => handlerRedirect()} footer={basicDialogFooter}>
                <p>{message && message}</p>
            </Dialog>

            <Dialog id='modalCancelacion' header="CONSULTA DE YOREMIA" visible={avisoY} draggable={false} blockScroll={false} resizable={false} style={{ width: '95%', height: '450px' }} onHide={onHideY} modal className="p-fluid">
                {dataY !== false ?
                    <div className='m-3 grid'>
                        <div className='col-12 lg:col-6 md:col-6 text-center align-content-center'>
                            <img className='w-7' src='assets\layout\images\logo-yoremia.png'></img>
                        </div>
                        <div className='col-12 lg:col-6 md:col-6 '>
                            <h5 className='col-12 text-center mb-5'>INFORMACIÓN DEL ALUMNO</h5>
                            <p><p style={{ fontWeight: "bold" }}>Nombre: </p>{dataY.curp} - {dataY.nombre} {dataY.apell1} {dataY.apell2}</p>
                            <p><p style={{ fontWeight: "bold" }}>CT actual: </p>{dataY.esccve}</p>
                            <p><p style={{ fontWeight: "bold" }}>Movimiento: </p>{dataY.movimiento}</p>
                            <p><p style={{ fontWeight: "bold" }}>Fecha último cambio: </p>{new Date(dataY.fecha).toLocaleDateString('en-GB')}</p>
                        </div>
                    </div>
                    :
                    <div className='m-3 grid'>
                        <div className='col-12 text-center'>
                            <img className='w-4' src='assets\layout\images\logo-yoremia.png'></img>
                        </div>
                        <div className='col-12'>
                            <h5 className='col-12 text-center mb-3 mt-3'>INFORMACIÓN</h5>
                            <p className='text-center'>{messageY && messageY}</p>
                        </div>
                    </div>}
            </Dialog>

            <Dialog id="modalEscanerQR" header="Escáner QR" resizable={false} draggable={false} visible={confirmScanner} onHide={() => { window.location.reload(); setConfirmScanner(false); setBanderaEscaner(false) }} style={{ width: '500px' }} modal className="p-fluid" >
                {confirmScanner && <ScannerFiltro carga={carga} />}
            </Dialog>

            <Dialog header='SELECCIONAR TUTOR' visible={dialogTutoresMulti} onHide={() => { setDialogTutoresMulti(!dialogTutoresMulti); setCheckboxValue([]) }} resizable={false} draggable={false} style={{ width: '500px' }} footer={TutoresMultiFooter} modal className="p-fluid">
                <div className='grid m-3'>
                    <div className='col-12 text-right'>
                        <label style={{ color: 'red' }}>* Campo obligatorio</label>
                    </div>
                    <div className='col-12'>
                        {dataMulti.length > 0 && ListaTutores(dataMulti).map((x, index) => {
                            return (

                                <div key={index.toString()} className="flex align-items-center mb-3">
                                    <Checkbox inputId={'checkOption' + x.IdTutor} name="option" value={x.IdTutor} checked={checkboxValue.indexOf(x.IdTutor) !== -1} onChange={onCheckboxChange} />
                                    <label style={{ fontWeight: 'bold' }} htmlFor={"ingredient1" + index.toString()} className="ml-2">{x.NombreTutor}</label>
                                </div>
                            )
                        })}
                        {/* {dataMulti.map((x, index) => {
                            return x.lstTutor.map((j, indexj) => {
                                return (

                                    <div key={index.toString + indexj.toString} className="flex align-items-center mb-3">
                                        <Checkbox inputId={'checkOption' + j.IdTutor} name="option" value={j.IdTutor} checked={checkboxValue.indexOf(j.IdTutor) !== -1} onChange={onCheckboxChange} />
                                        <label style={{ fontWeight: 'bold' }} htmlFor={"ingredient1" + index.toString + indexj.toString} className="ml-2">{j.NombreTutor}</label>
                                    </div>
                                )
                            })
                        })} */}
                    </div>
                    <div className='col-12'>
                        <Messages ref={msgs} id='alertTutorMulti' />
                    </div>
                    {dataMulti.length > 0 && ListaTutores(dataMulti).length === 0 &&
                        <div className='col-12'>
                            < MessageDetail color='warn' mensaje="DEBE AGREGAR TUTOR" />
                        </div>}
                </div>
            </Dialog>
        </>
    )
}

export default Filtro;